<template>
  <div class="project-setting">
    <el-page-header
      @back="onBack"
      content="项目设置"
      style="z-index: 19"
    ></el-page-header>
    <el-collapse v-model="activeCollapses">
      <el-collapse-item name="baseInfo">
        <template #title>
          <base-section
            label="基本信息"
            style="margin: 0; padding: 0"
          ></base-section>
        </template>

        <div style="margin-left: 40px">
          <project-info :value="project"></project-info>
        </div>
      </el-collapse-item>
      <el-collapse-item name="setting">
        <template #title>
          <base-section
            label="设置"
            style="margin: 0; padding: 0"
          ></base-section>
        </template>
        <el-tabs v-model="activeName">
          <el-tab-pane label="账号管理" name="userManage" lazy>
            <project-user
              ref="projectUser"
              :project="project"
              :active="activeName == 'userManage'"
            ></project-user>
          </el-tab-pane>
          <el-tab-pane label="角色管理" name="roleManage" lazy>
            <project-role
              ref="projectRole"
              :project="project"
              :active="activeName == 'roleManage'"
            ></project-role>
          </el-tab-pane>
          <el-tab-pane label="资源管理" name="resourceManage" lazy>
            <project-resource2
              ref="projectResource"
              :project="project"
              :active="activeName == 'resourceManage'"
            ></project-resource2>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import ProjectInfo from '../components/ProjectInfo.vue'
export default {
  components: { ProjectInfo },
  name: 'project-setting',
  data() {
    return {
      activeName: 'userManage',
      activeCollapses: ['baseInfo', 'setting'],
      project: {
        id: this.$route.query.id
      }
    }
  },
  created() {
    this.getProjectInfo()
  },
  methods: {
    onBack() {
      this.$router.go(-1)
    },
    getProjectInfo() {
      this.$post('/project/find', {
        id: JSON.stringify({
          Field: 'id',
          ComparePattern: 1,
          Values: [this.project.id]
        })
      }).then((resp) => {
        if (resp.data.code == 0 && resp.data.data.Data.length > 0) {
          this.project = resp.data.data.Data[0]
        } else {
          this.$message(resp.data.msg || '获取项目信息失败')
        }
      })
    },
    selectRoleRes(resIds) {
      // this.$refs.projectResource.setCheckedKeys(resIds)
    }
  }
}
</script>
<style lang="less">
.project-setting {
  padding: 0 15px;
  .el-page-header {
    padding: 15px 0;
    position: sticky;
    top: 0;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(255, 255, 255, 1) 40%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  .section-col-wrap {
    display: flex;
    justify-content: space-between;
    .section-col {
      width: 48%;
    }
  }
}
</style>
